<template>
  <div>
    <ul :class="`nav nav-tabs ${navClass}`">
      <template v-for="(tab, tabIndex) in tabs">
        <li
          v-if="tab.type !== 'done'"
          v-bind:key="tab.name"
          :class="{ 'nav-item': true, 'step-doing': tab.isActive, 'step-done': tab.isDone }"
        >
          <a
            :class="{
              'nav-link': true,
              disabled: topNavDisabled
            }"
            href="#"
            @click.prevent="clickedTab(tabIndex)"
          >
            <span>{{ tab.name }}</span>
            <small>{{ tab.desc }}</small>
          </a>
        </li>
      </template>
    </ul>

    <slot></slot>

    <div :class="`wizard-buttons ${navClass}`" v-if="!(lastStepEnd && isCompleted)">
      <slot
        name="wizard-buttons"
        :current-index="currentActive"
        :is-first="isFirst"
        :is-last="isLast"
        :previous-handler="previousTab"
        :next-handler="nextTab"
      >
        <button
          type="button"
          class="mr-1 btn btn-primary"
          :disabled="isFirst"
          @click="previousTab()"
        >
          上一步
        </button>
        <button
          v-if="isLast"
          type="button"
          class="btn btn-primary"
          :disabled="!isLast"
          @click="nextTab()"
        >
          完成
        </button>
        <button
          v-else
          type="button"
          class="btn btn-primary"
          :disabled="isLast"
          @click="nextTab()"
        >
          下一步
        </button>
      </slot>
    </div>
  </div>
</template>

<script>
/* eslint-disable no-param-reassign */

export default {
  name: 'FormWizard',

  props: {
    navClass: {
      default: 'justify-content-center',
    },
    lastStepEnd: {
      default: false,
    },
    topNavDisabled: {
      default: false,
    },
    withValidate: {
      default: false,
    },
    done: {
      type: Function,
      default: null,
    },
  },
  data() {
    return {
      tabs: [],
      currentActive: 0,
      totalTabs: 0,
      isCompleted: false,
    };
  },
  computed: {
    isFirst() {
      return this.currentActive === 0;
    },
    isLast() {
      return this.currentActive === this.totalTabs - 1;
    },
  },

  created() {
    this.tabs = this.$children;
  },
  mounted() {
    this.totalTabs = this.tabs.filter((x) => x.type !== 'done').length;
  },
  methods: {
    tabStatusFix() {
      this.tabs.forEach((tab, tabIndex) => {
        let { isDone } = tab;
        if (!isDone) {
          isDone = this.currentActive > tabIndex;
        }
        tab.isDone = isDone;
        tab.isActive = false;
      });
    },
    clickedTab(tabIndex) {
      if (!this.topNavDisabled) {
        if (!(this.lastStepEnd && this.isCompleted)) {
          this.currentActive = tabIndex;
          this.tabStatusFix();
          this.tabs[this.currentActive].isActive = true;
        }
      }
    },
    previousTab() {
      this.currentActive -= 1;
      this.tabStatusFix();
      this.tabs[this.currentActive].isActive = true;
      this.$emit('changed', this.currentActive);
    },

    async nextTab() {
      let valid = false;

      if (this.withValidate === true && this.tabs[this.currentActive].validate) {
        let validateResult = false;
        let submitResult = false;

        validateResult = await this.tabs[this.currentActive].validate();
        console.log(validateResult);

        if (validateResult === true && this.tabs[this.currentActive].submit) {
          submitResult = await this.tabs[this.currentActive].submit();
        }
        console.log(submitResult);

        if (validateResult === true && submitResult === true) {
          valid = true;
        }
      } else {
        valid = true;
      }

      if (valid === true) {
        this.doNextTab();
      }
    },

    doNextTab() {
      const nextActive = this.currentActive + 1;

      if (nextActive >= this.totalTabs) {
        this.isCompleted = true;
        const doneTab = this.tabs.find((x) => x.type === 'done');
        if (doneTab) {
          doneTab.isActive = true;
        } else {
          const activeTab = this.tabs[this.currentActive - 1];
          if (activeTab) {
            activeTab.isActive = true;
          }
          if (this.done) {
            this.done();
          }
        }
      } else {
        this.currentActive = nextActive;
        this.tabStatusFix();
        this.tabs[this.currentActive].isActive = true;
        this.$emit('changed', this.currentActive);
      }
    },
  },
};
</script>
